<template>
  <div
    style="position: absolute;left:0;top:0;z-index: 300;font-family: proxima-nova, sans-serif"
  >
    <transition name="fade" appear>
      <div v-if="dialog">
        <div
          style="background-color: rgba(33,33,33, .46);width:100vw;height:100vh;position: absolute;left:0;top:0;z-index: 301"
        ></div>
        <div
          style="width:100vw;height:100vh;position: absolute;left:0;right:0;z-index: 302"
          class="flex-block-center"
        >
          <transition v-if="dialog" name="scroll-y-reverse-transition">
            <div class="window">
              <div v-html="text"></div>
              <div style="text-align: center;padding-top:30px">
                <span class="btn" @click="cancel">
                  NO
                </span>
                <span class="btn" @click="ok" style="margin-left: 100px">
                  YES
                </span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Confirm",
  data() {
    return {
      dialog: false,
      text: null,
      resolver: null
    };
  },
  methods: {
    ok() {
      this.dialog = false;
      this.$emit("ok");
      this.resolver(true);
    },
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
      this.resolver(false);
    },
    open(text) {
      this.text = text;
      this.dialog = true;
      return new Promise(resolve => (this.resolver = resolve));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./hive";
</style>
